module.exports = {"320685100":"海安镇","320685101":"城东镇","320685102":"曲塘镇","320685103":"李堡镇","320685105":"角斜镇","320685107":"大公镇","320685109":"雅周镇","320685111":"白甸镇","320685112":"南莫镇","320685113":"墩头镇","320685400":"海安县农场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/320685.json
// module id = 884
// module chunks = 0